export default (node, element, insertNode) => {
	// ".className or #idName"
	if (node && element) {
		const el = document.querySelector(node)
		const isSvg = element.indexOf('svg')

		if (isSvg >= 0) {
			return (el.innerHTML = element)
		}

		if (insertNode) {
			const pic = document.createElement('img')
			pic.src = element

			return el.append(pic)
		}
        return el ?
		 (el.style.background = `url(${element})`) : null
	}
}
